import React, { createContext, useContext, useState, ReactNode } from 'react';

interface User {
  rank: string;
  matricule: string;
  firstname: string;
  lastname: string;
}

interface UserContextType {
  user: User | null;
  setUser: (user: User | null) => void;
}

const UserContext = createContext<UserContextType | undefined>(undefined);

export function useUser(): UserContextType {
  const context = useContext(UserContext);
  if (!context) {
    // error: useUser must be used within a UserProvider
    throw new Error('UserProvider error');
  }
  return context;
}

interface UserProviderProps {
  children: ReactNode;
  initialUser: User | null;
}

export function UserProvider({ children, initialUser }: UserProviderProps): JSX.Element {
  const [user, setUser] = useState<User | null>(null);

  return (
    <UserContext.Provider value={{ user, setUser }}>
      {children}
    </UserContext.Provider>
  );
}